import { ReactNode } from "react";
import { ReadOnlyBadge } from "~/components/ReadOnlyBadge";

interface AgentTabHeaderProps {
  title: string;
  count?: number;
  max?: number;
  context?: string;
  description?: ReactNode;
  action?: ReactNode;
  isSystemAgent?: boolean;
}

export const AgentTabHeader = ({
  title,
  count,
  max,
  context,
  description,
  action,
  isSystemAgent,
}: AgentTabHeaderProps) => {
  const showCounter = count !== undefined && max !== undefined;
  const showMeta = showCounter || !!context;

  return (
    <div className="flex flex-col gap-3">
      <div className="flex items-start justify-between gap-3">
        <div className="flex min-w-0 flex-col gap-1">
          <div className="flex items-center gap-2">
            <h2 className="text-2xl font-semibold">{title}</h2>
            {isSystemAgent && <ReadOnlyBadge />}
          </div>
          {showMeta && (
            <p className="text-xs text-muted-foreground">
              {showCounter && (
                <>
                  {count} of {max}
                </>
              )}
              {showCounter && context && <span className="mx-1.5">·</span>}
              {context}
            </p>
          )}
        </div>
        {action && <div className="shrink-0">{action}</div>}
      </div>
      {description && <p className="text-sm text-muted-foreground">{description}</p>}
    </div>
  );
};
